var R = ':host{--sanbera-ai-bg:#f8f7f2;--sanbera-ai-surface:#fff;--sanbera-ai-text:#202020;--sanbera-ai-muted:#666;--sanbera-ai-accent:#000;--sanbera-ai-border:#d9d9d9;--sanbera-ai-radius:18px;--sanbera-ai-collision-bottom:0px;--sanbera-ai-panel-collision-bottom:min(160px, var(--sanbera-ai-collision-bottom));--sanbera-ai-bottom-inset:0px;--sanbera-ai-aligned-right:20px;color:var(--sanbera-ai-text);font-family:inherit;line-height:1.45}*,:before,:after{box-sizing:border-box}.launcher{z-index:2147482000;right:max(20px, env(safe-area-inset-right));bottom:max(20px, env(safe-area-inset-bottom), var(--sanbera-ai-collision-bottom));color:#fff;cursor:pointer;touch-action:manipulation;background:#000 radial-gradient(circle at 36% 28%,#363636 0%,#1b1b1b 44%,#090909 100%);border:2px solid #f4f4f1eb;border-radius:50%;place-items:center;width:55px;height:55px;padding:0;transition:transform .16s,box-shadow .16s,filter .16s;display:grid;position:fixed;box-shadow:0 0 0 1px #141414e0,inset 0 1px 1px #ffffff2e,inset 0 -2px 4px #0000009e,0 7px 18px #0000003d}:host([data-accessibility-aligned]) .launcher{right:max(env(safe-area-inset-right), var(--sanbera-ai-aligned-right))}.launcher-mark{color:#eeeeeb;letter-spacing:.045em;text-indent:.045em;text-shadow:0 -1px #ffffff3d,0 1px 1px #000000f2,0 2px 3px #0009;font-family:Helvetica Neue,Arial,sans-serif;font-size:14px;font-weight:800;line-height:1;display:block}@media (hover:hover){.launcher:hover{filter:brightness(1.08);transform:translateY(-1px);box-shadow:0 0 0 1px #141414eb,inset 0 1px 1px #ffffff38,inset 0 -2px 4px #000000a6,0 9px 22px #00000047}}.launcher:active{filter:brightness(.94);transform:scale(.965);box-shadow:0 0 0 1px #141414eb,inset 0 2px 5px #000000c7,inset 0 -1px #ffffff1a,0 4px 12px #00000038}:host([data-continuing]) .launcher:after{content:"";background:#fff;border-radius:50%;width:11px;height:11px;position:absolute;top:4px;right:4px;box-shadow:0 0 0 2px #000}.launcher:focus-visible{outline-offset:3px;outline:3px solid #fff}.panel{z-index:2147482001;right:max(20px, env(safe-area-inset-right));bottom:max(88px, calc(env(safe-area-inset-bottom) + 76px), var(--sanbera-ai-collision-bottom));border:1px solid var(--sanbera-ai-border);border-radius:var(--sanbera-ai-radius);background:var(--sanbera-ai-surface);grid-template-rows:auto minmax(0,1fr) auto auto;width:min(380px,100vw - 32px);height:min(590px,100dvh - 120px);min-height:min(200px,100dvh - 20px);display:grid;position:fixed;overflow:hidden;box-shadow:0 18px 54px #00000038}.hidden{display:none!important}:host([data-shopify-preview]) .launcher{bottom:max(88px, calc(env(safe-area-inset-bottom) + 76px), var(--sanbera-ai-collision-bottom))}:host([data-shopify-preview]) .panel{bottom:max(150px, calc(env(safe-area-inset-bottom) + 138px), var(--sanbera-ai-collision-bottom));height:min(590px,100dvh - 182px)}.header{color:#fff;background:var(--sanbera-ai-accent);align-items:center;gap:10px;padding:14px 16px;display:flex}.heading{flex:1;min-width:0}.title{margin:0;font-size:16px;font-weight:700}.subtitle{opacity:.82;margin:1px 0 0;font-size:12px}.icon-button{min-width:40px;min-height:40px;color:inherit;cursor:pointer;font:inherit;background:#ffffff1f;border:0;border-radius:999px}.messages{background:var(--sanbera-ai-bg);overscroll-behavior:contain;min-height:0;padding:16px;overflow-y:auto}.message{overflow-wrap:anywhere;unicode-bidi:plaintext;border-radius:14px;max-width:88%;margin:0 0 12px;padding:10px 12px;font-size:14px}.message[dir=rtl]{text-align:right}.message p{white-space:pre-wrap;margin:0}.message p+p,.message ul+p,.message ol+p,.message p+ul,.message p+ol{margin-top:8px}.message ul,.message ol{margin:0;padding-inline-start:20px}.message li+li{margin-top:4px}.assistant{border:1px solid var(--sanbera-ai-border);background:#fff}.user{color:#fff;background:var(--sanbera-ai-accent);margin-left:auto}.links{gap:6px;max-width:88%;margin:-4px 0 14px;display:grid}.link-card{border:1px solid var(--sanbera-ai-border);min-height:44px;color:var(--sanbera-ai-text);background:#fff;border-radius:12px;grid-template-columns:minmax(0,1fr) auto;align-items:center;column-gap:12px;padding:9px 12px;text-decoration:none;transition:border-color .14s,background-color .14s;display:grid}.link-kind,.link-title,.link-where{text-overflow:ellipsis;white-space:nowrap;grid-column:1;min-width:0;overflow:hidden}.link-kind{letter-spacing:.08em;text-transform:uppercase;color:var(--sanbera-ai-muted);font-size:10.5px;font-weight:600}.link-title{margin-top:1px;font-size:13.5px;font-weight:600;line-height:1.3}.link-where{color:var(--sanbera-ai-muted);margin-top:1px;font-size:11.5px}.link-arrow{grid-area:1/2/span 3;font-size:16px;line-height:1;transition:transform .14s}@media (hover:hover){.link-card:hover{border-color:var(--sanbera-ai-accent)}.link-card:hover .link-arrow{transform:translate(2px)}}.link-card:active{background:var(--sanbera-ai-bg)}.links[dir=rtl] .link-arrow{transform:scaleX(-1)}.choices{flex-wrap:wrap;gap:7px;margin:-4px 0 14px;display:flex}.choice{border:1px solid var(--sanbera-ai-accent);min-height:40px;color:var(--sanbera-ai-accent);cursor:pointer;font:inherit;touch-action:manipulation;background:#fff;border-radius:999px;padding:9px 14px;font-size:13px;font-weight:600;transition:background-color .12s,color .12s}@media (hover:hover){.choice:hover{color:#fff;background:var(--sanbera-ai-accent)}}.choice:active{color:#fff;background:var(--sanbera-ai-accent)}.suggestions{gap:7px;padding:9px 12px 0;display:flex;overflow-x:auto}.suggestion.primary{color:#fff;background:var(--sanbera-ai-accent);border-color:var(--sanbera-ai-accent);font-weight:600}.suggestion{border:1px solid var(--sanbera-ai-border);min-height:36px;color:var(--sanbera-ai-text);cursor:pointer;font:inherit;background:#fff;border-radius:999px;flex:none;padding:7px 10px;font-size:12px}.composer{align-items:end;gap:8px;padding:10px 12px;display:flex}.input{resize:none;border:1px solid var(--sanbera-ai-border);width:100%;min-height:44px;max-height:120px;color:var(--sanbera-ai-text);font:inherit;background:#fff;border-radius:12px;padding:10px;font-size:16px}.send{color:#fff;background:var(--sanbera-ai-accent);cursor:pointer;min-width:48px;min-height:44px;font:inherit;border:0;border-radius:12px;font-weight:700}.send:disabled{cursor:not-allowed;opacity:.55}.note{color:var(--sanbera-ai-muted);margin:0;padding:0 12px 11px;font-size:11px}button:focus-visible,textarea:focus-visible,a:focus-visible{outline-offset:2px;outline:3px solid #000}@media (width<=520px){.launcher{right:max(14px, env(safe-area-inset-right));bottom:max(14px, env(safe-area-inset-bottom), var(--sanbera-ai-collision-bottom))}.panel{inset:max(10px, env(safe-area-inset-top)) max(10px, env(safe-area-inset-right)) calc(max(10px, env(safe-area-inset-bottom), var(--sanbera-ai-panel-collision-bottom)) + var(--sanbera-ai-bottom-inset)) max(10px, env(safe-area-inset-left));border-radius:16px;width:auto;height:auto;max-height:none}:host([data-shopify-preview]) .launcher{bottom:max(80px, calc(env(safe-area-inset-bottom) + 68px), var(--sanbera-ai-collision-bottom))}:host([data-shopify-preview]) .panel{inset:max(10px, env(safe-area-inset-top)) max(10px, env(safe-area-inset-right)) calc(max(72px, calc(env(safe-area-inset-bottom) + 60px), var(--sanbera-ai-panel-collision-bottom)) + var(--sanbera-ai-bottom-inset)) max(10px, env(safe-area-inset-left));height:auto;max-height:none}}@media (prefers-reduced-motion:reduce){*,:before,:after{scroll-behavior:auto!important;transition:none!important;animation:none!important}}:host([data-keyboard]) .panel{top:calc(max(10px, env(safe-area-inset-top)) + var(--sanbera-ai-viewport-top,0px));bottom:calc(max(10px, env(safe-area-inset-bottom), var(--sanbera-ai-panel-collision-bottom)) + var(--sanbera-ai-bottom-inset));height:auto;max-height:none}', I = 55, z = 14, O = 14;
function N(e, t, n = I, i = z) {
  if (!e || e.width <= 0 || e.height <= 0) return null;
  const s = e.bottom > 0 && e.top < t.bottom && e.right > 0 && e.left < t.width, r = e.right > t.width / 2;
  if (!s || !r) return null;
  const o = t.bottom - e.top + i, l = Math.max(0, t.bottom - n - O);
  return Math.max(0, Math.min(Math.ceil(o), l));
}
function $(e, t, n = I) {
  if (!e || e.width <= 0 || e.height <= 0 || t <= 0) return null;
  const i = e.right > 0 && e.left < t, s = e.right > t / 2;
  if (!i || !s) return null;
  const r = (e.left + e.right) / 2;
  return Math.max(0, t - r - n / 2);
}
var _ = {
  amp: "&",
  apos: "'",
  gt: ">",
  lt: "<",
  nbsp: " ",
  quot: '"'
};
function L(e) {
  return e.replace(/&(?:#(x[0-9a-f]+|\d+)|([a-z]+));/giu, (t, n, i) => {
    if (i) return _[i.toLowerCase()] ?? t;
    if (!n) return t;
    const s = n.toLowerCase().startsWith("x") ? Number.parseInt(n.slice(1), 16) : Number.parseInt(n, 10);
    return !Number.isSafeInteger(s) || s < 32 || s > 1114111 || s >= 55296 && s <= 57343 ? s === 32 || s === 160 ? " " : "" : String.fromCodePoint(s);
  }).replace(/\\([*_`#])/gu, "$1").replace(/[\u202A-\u202E\u2066-\u2069]/gu, "").replace(/\r\n?/gu, `
`).trim();
}
function k(e) {
  const t = [], n = /\*\*([^*\n]+)\*\*/gu;
  let i = 0;
  for (const s of e.matchAll(n)) {
    const r = s.index ?? 0;
    r > i && t.push({
      kind: "text",
      value: e.slice(i, r)
    }), t.push({
      kind: "strong",
      value: s[1] ?? ""
    }), i = r + s[0].length;
  }
  return i < e.length && t.push({
    kind: "text",
    value: e.slice(i)
  }), t.length ? t : [{
    kind: "text",
    value: e
  }];
}
function B(e) {
  const t = L(e).split(`
`), n = [];
  let i = [], s = null, r = [];
  const o = () => {
    i.length && (n.push({
      kind: "paragraph",
      lines: [k(i.join(`
`).replace(/^#{1,6}\s+/u, ""))]
    }), i = []);
  }, l = () => {
    !s || !r.length || (n.push({
      kind: s,
      lines: r
    }), s = null, r = []);
  };
  for (const c of t) {
    const h = c.match(/^\s*[-*•]\s+(.+)$/u), u = c.match(/^\s*\d+[.)]\s+(.+)$/u);
    if (h || u) {
      o();
      const p = h ? "unordered-list" : "ordered-list";
      s && s !== p && l(), s = p, r.push(k((h?.[1] ?? u?.[1] ?? "").trim()));
      continue;
    }
    l(), c.trim() ? i.push(c) : o();
  }
  return l(), o(), n;
}
function H(e) {
  const t = L(e);
  return /[\p{Script=Arabic}\p{Script=Hebrew}]/u.test(t) ? "rtl" : new RegExp("\\p{Script=Latin}", "u").test(t) ? "ltr" : "auto";
}
function S(e, t) {
  for (const n of t) if (n.kind === "strong") {
    const i = document.createElement("strong");
    i.textContent = n.value, e.append(i);
  } else e.append(document.createTextNode(n.value));
}
function W(e) {
  const t = document.createDocumentFragment();
  for (const n of B(e)) {
    if (n.kind === "paragraph") {
      const s = document.createElement("p");
      S(s, n.lines[0] ?? []), t.append(s);
      continue;
    }
    const i = document.createElement(n.kind === "ordered-list" ? "ol" : "ul");
    for (const s of n.lines) {
      const r = document.createElement("li");
      S(r, s), i.append(r);
    }
    t.append(i);
  }
  return t;
}
var q = "https://www.sanbera.com", D = [
  {
    handle: "women-essential-day-to-day",
    title: "Daily Essential Women",
    audience: "women",
    role: "day"
  },
  {
    handle: "women-reload-time-to-time",
    title: "Nightly Reload Women",
    audience: "women",
    role: "night"
  },
  {
    handle: "men-essential-day-to-day",
    title: "Daily Essential Men",
    audience: "men",
    role: "day"
  },
  {
    handle: "men-reload-time-to-time",
    title: "Nightly Reload Men",
    audience: "men",
    role: "night"
  }
], g = {
  en: {
    start: "Find my formula",
    audience: "Three quick questions and I’ll point you to the right formula. Who is it for?",
    focus: "When would you like support?",
    plan: "How would you like to buy it?",
    choices: {
      audience: [{
        value: "women",
        label: "For women"
      }, {
        value: "men",
        label: "For men"
      }],
      focus: [
        {
          value: "day",
          label: "During the day"
        },
        {
          value: "night",
          label: "In the evening"
        },
        {
          value: "both",
          label: "Day and night"
        }
      ],
      plan: [
        {
          value: "once",
          label: "Try it once"
        },
        {
          value: "monthly",
          label: "Monthly"
        },
        {
          value: "quarterly",
          label: "Quarterly"
        }
      ]
    },
    match: {
      day: (e) => `Your match: **${e}**, the daytime formula.`,
      night: (e) => `Your match: **${e}**, the evening formula.`,
      both: (e, t) => `Your match is the Day and Night routine: **${e}** in the morning and **${t}** in the evening.`
    },
    plans: {
      once: "Choose **One-time Purchase** on the product page, with no commitment.",
      monthly: "Choose **Monthly** on the product page.",
      quarterly: "Choose **Quarterly** on the product page."
    },
    close: "Ask me anything about it: what’s inside, how to take it, or delivery.",
    followUps: ["What’s inside?", "How do I take it?"],
    restart: "Start again"
  },
  de: {
    start: "Meine Formel finden",
    audience: "Drei kurze Fragen, und ich zeige Ihnen die passende Formel. Für wen ist sie?",
    focus: "Wann wünschen Sie Unterstützung?",
    plan: "Wie möchten Sie kaufen?",
    choices: {
      audience: [{
        value: "women",
        label: "Für Frauen"
      }, {
        value: "men",
        label: "Für Männer"
      }],
      focus: [
        {
          value: "day",
          label: "Tagsüber"
        },
        {
          value: "night",
          label: "Am Abend"
        },
        {
          value: "both",
          label: "Tag und Nacht"
        }
      ],
      plan: [
        {
          value: "once",
          label: "Einmal ausprobieren"
        },
        {
          value: "monthly",
          label: "Monatlich"
        },
        {
          value: "quarterly",
          label: "Vierteljährlich"
        }
      ]
    },
    match: {
      day: (e) => `Ihre Empfehlung: **${e}**, die Formel für den Tag.`,
      night: (e) => `Ihre Empfehlung: **${e}**, die Formel für den Abend.`,
      both: (e, t) => `Ihre Empfehlung ist die Tag-und-Nacht-Routine: **${e}** am Morgen und **${t}** am Abend.`
    },
    plans: {
      once: "Wählen Sie auf der Produktseite **Einmaliger Kauf**, ohne Verpflichtung.",
      monthly: "Wählen Sie auf der Produktseite **Monatlich**.",
      quarterly: "Wählen Sie auf der Produktseite **Vierteljährlich**."
    },
    close: "Fragen Sie mich gern alles dazu: Inhaltsstoffe, Einnahme oder Versand.",
    followUps: ["Was ist drin?", "Wie nehme ich es ein?"],
    restart: "Neu starten"
  }
}, T = [
  "audience",
  "focus",
  "plan"
], K = {
  audience: ["women", "men"],
  focus: [
    "day",
    "night",
    "both"
  ],
  plan: [
    "once",
    "monthly",
    "quarterly"
  ]
};
function P(e) {
  return T.find((t) => e[t] === void 0) ?? null;
}
function C(e) {
  return P(e) === null;
}
function E(e, t) {
  const n = g[t];
  return {
    step: e,
    prompt: n[e],
    choices: n.choices[e].map((i) => ({ ...i }))
  };
}
function M(e, t, n) {
  return K[t].includes(n) ? {
    ...e,
    [t]: n
  } : e;
}
function U(e) {
  if (!e || typeof e != "object") return {};
  const t = e;
  let n = {};
  for (const i of T) typeof t[i] == "string" && (n = M(n, i, t[i]));
  return n;
}
function V(e, t) {
  return `${q}${t === "de" ? "/de" : ""}/products/${e}`;
}
function Y(e) {
  return (e.focus === "both" ? ["day", "night"] : [e.focus]).map((t) => D.find((n) => n.audience === e.audience && n.role === t)).filter((t) => !!t);
}
function j(e, t) {
  const n = g[t], i = Y(e);
  return {
    text: `${e.focus === "both" ? n.match.both(i[0].title, i[1].title) : n.match[e.focus](i[0].title)}

${n.plans[e.plan]}

${n.close}`,
    links: i.map((s) => ({
      title: s.title,
      url: V(s.handle, t)
    }))
  };
}
function Q(e) {
  return C(e) ? { product_finder: {
    audience: e.audience,
    focus: e.focus,
    plan: e.plan
  } } : void 0;
}
var G = {
  en: {
    product: "Product",
    page: "Page",
    policy: "Policy"
  },
  de: {
    product: "Produkt",
    page: "Seite",
    policy: "Richtlinie"
  }
};
function X(e, t) {
  const n = new URL(e).pathname, i = G[t];
  return /\/products\//u.test(n) ? i.product : /\/policies\/|shipping-policy|legal-notice/u.test(n) ? i.policy : i.page;
}
function J(e) {
  const { hostname: t, pathname: n } = new URL(e), i = t.replace(/^www\./u, ""), s = n.split("/").filter(Boolean).filter((r) => r !== "de");
  return s.length ? `${i} › ${s[0]}` : i;
}
function Z(e, t) {
  try {
    const n = new URL(e), i = new URL(t);
    return n.hostname === i.hostname && n.pathname.replace(/\/$/u, "") === i.pathname.replace(/\/$/u, "");
  } catch {
    return !1;
  }
}
var m = "sanbera-ai-session-v1", ee = [
  "audience",
  "focus",
  "plan"
], te = "csm-web-accessibility", ie = "#csm-ada-compliance-wrapper", ne = 180, A = 200, b = "(max-width: 520px)";
function a(e, t, n) {
  const i = document.createElement(e);
  return t && (i.className = t), n && (i.textContent = n), i;
}
function se() {
  return document.documentElement.lang.toLowerCase().startsWith("de") || location.pathname.startsWith("/de") ? "de" : "en";
}
var x = {
  en: {
    welcome: "Hi! I’m the Sanbera AI Agent. I can help with Sanbera products, purchase options and information.",
    subtitle: "AI product guide",
    placeholder: "Ask about Sanbera…",
    send: "Send",
    close: "Close chat",
    reset: "Reset conversation",
    open: "Open Sanbera AI product guide",
    note: "AI product guide. For personal medical advice, speak with a healthcare professional.",
    error: "The Sanbera AI product guide is temporarily unavailable. Please contact Sanbera support.",
    suggestions: [
      "Which product is right for daytime?",
      "What’s the difference between Daily and Nightly?",
      "How does Quarterly work?"
    ]
  },
  de: {
    welcome: "Hallo! Ich bin der Sanbera AI Agent. Ich helfe bei Fragen zu Sanbera-Produkten, Kaufoptionen und Informationen.",
    subtitle: "KI-Produktguide",
    placeholder: "Fragen Sie nach Sanbera…",
    send: "Senden",
    close: "Chat schließen",
    reset: "Unterhaltung zurücksetzen",
    open: "Sanbera KI-Produktguide öffnen",
    note: "KI-Produktguide. Für persönliche medizinische Beratung wenden Sie sich bitte an medizinisches Fachpersonal.",
    error: "Der Sanbera AI-Produktguide ist vorübergehend nicht verfügbar. Bitte kontaktieren Sie den Sanbera-Support.",
    suggestions: [
      "Welches Produkt ist für tagsüber?",
      "Was ist der Unterschied zwischen Daily und Nightly?",
      "Wie funktioniert Quarterly?"
    ]
  }
};
function F(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  if (typeof t.title != "string" || typeof t.url != "string") return null;
  try {
    const n = new URL(t.url);
    return n.protocol !== "https:" || n.hostname !== "www.sanbera.com" ? null : {
      title: t.title.slice(0, 120),
      url: n.href
    };
  } catch {
    return null;
  }
}
function re(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  if (t.role !== "user" && t.role !== "assistant" || typeof t.content != "string") return null;
  const n = {
    role: t.role,
    content: t.content.slice(0, 4e3)
  };
  if (Array.isArray(t.sources)) {
    const s = t.sources.map((r) => F(r)).filter((r) => r !== null).slice(0, 3);
    s.length && (n.sources = s);
  }
  const i = t.question;
  if (i && ee.includes(i.step) && Array.isArray(i.choices)) {
    const s = i.choices.filter((r) => !!r && typeof r.value == "string" && typeof r.label == "string").map((r) => ({
      value: r.value.slice(0, 20),
      label: r.label.slice(0, 60)
    }));
    s.length && (n.question = {
      step: i.step,
      choices: s
    });
  }
  return t.finderResult === !0 && (n.finderResult = !0), t.finderTurn === !0 && (n.finderTurn = !0), n;
}
var ae = class extends HTMLElement {
  #A;
  #s;
  #l;
  #n;
  #y;
  #i;
  #c;
  #f;
  #e = [];
  #r = {};
  #I = !1;
  #h = !1;
  #o = se();
  #d = null;
  #m = null;
  #u = null;
  #b = null;
  #L = null;
  #a = null;
  #w = [];
  #g = [];
  #v = !1;
  #p = !1;
  #k = null;
  #S = 0;
  #E = null;
  #t = () => {
    this.#d === null && (this.#d = window.requestAnimationFrame(() => {
      this.#d = null, this.syncFloatingCollision();
    }));
  };
  constructor() {
    super(), this.#A = this.attachShadow({ mode: "open" });
    const e = a("style");
    e.textContent = R, this.#A.append(e);
    const t = x[this.#o];
    this.#s = a("button", "launcher"), this.#s.type = "button", this.#s.setAttribute("aria-label", t.open), this.#s.setAttribute("aria-expanded", "false");
    const n = a("span", "launcher-mark", "AI");
    n.setAttribute("aria-hidden", "true"), this.#s.append(n), this.#l = a("section", "panel hidden"), this.#l.setAttribute("role", "dialog"), this.#l.setAttribute("aria-label", "Sanbera AI");
    const i = a("div", "header"), s = a("div", "heading");
    s.append(a("p", "title", "Sanbera AI"), a("p", "subtitle", t.subtitle));
    const r = a("button", "icon-button", "↻");
    r.type = "button", r.setAttribute("aria-label", t.reset);
    const o = a("button", "icon-button", "×");
    o.type = "button", o.setAttribute("aria-label", t.close), i.append(s, r, o), this.#n = a("div", "messages"), this.#n.setAttribute("role", "log"), this.#n.setAttribute("aria-live", "polite"), this.#n.setAttribute("aria-relevant", "additions text"), this.#y = a("div", "suggestions");
    const l = a("div", "composer");
    this.#i = a("textarea", "input"), this.#i.rows = 1, this.#i.maxLength = 2e3, this.#i.placeholder = t.placeholder, this.#i.setAttribute("aria-label", t.placeholder), this.#c = a("button", "send", t.send), this.#c.type = "button", l.append(this.#i, this.#c);
    const c = a("p", "note", t.note);
    this.#l.append(i, this.#n, this.#y, l, c), this.#A.append(this.#s, this.#l), this.#s.addEventListener("click", () => this.open()), o.addEventListener("click", () => this.close()), r.addEventListener("click", () => this.reset()), this.#c.addEventListener("click", () => {
      this.submit();
    }), this.#i.addEventListener("focus", () => {
      this.#p = !0, this.scheduleKeyboardSync();
    }, { passive: !0 }), this.#i.addEventListener("blur", () => {
      this.#p = !1, this.scheduleKeyboardSync();
    }, { passive: !0 }), this.#i.addEventListener("keydown", (h) => {
      h.key === "Enter" && !h.shiftKey && (h.preventDefault(), this.submit());
    }), this.#l.addEventListener("keydown", (h) => {
      h.key === "Escape" && this.close();
    }), this.syncShopifyPreviewOffset();
    for (const h of [
      250,
      1e3,
      2500
    ]) window.setTimeout(() => this.syncShopifyPreviewOffset(), h);
    this.restore();
  }
  connectedCallback() {
    if (!this.#m) {
      this.#m = new MutationObserver(this.#t), this.#m.observe(document.documentElement, {
        childList: !0,
        subtree: !0
      }), this.#b = new ResizeObserver(this.#t), window.addEventListener("resize", this.#t, { passive: !0 }), window.addEventListener("orientationchange", this.#t, { passive: !0 }), window.visualViewport?.addEventListener("resize", this.#t, { passive: !0 }), window.visualViewport?.addEventListener("scroll", this.#t, { passive: !0 }), window.visualViewport?.addEventListener("resize", this.#x, { passive: !0 }), window.addEventListener("orientationchange", this.#T, { passive: !0 });
      for (const e of [
        0,
        250,
        1e3,
        2500,
        5e3,
        1e4
      ]) this.#w.push(window.setTimeout(this.#t, e));
      this.resumeAfterNavigation();
    }
  }
  resumeAfterNavigation() {
    !this.#I || this.#e.length === 0 || (this.#I = !1, window.matchMedia(b).matches ? this.setAttribute("data-continuing", "") : this.open({ focus: !1 }));
  }
  disconnectedCallback() {
    this.#m?.disconnect(), this.#u?.disconnect(), this.#b?.disconnect(), this.#m = null, this.#u = null, this.#b = null, this.#L = null, this.#a instanceof HTMLElement && (this.#a.removeEventListener("transitionend", this.#t), this.#a.removeEventListener("animationend", this.#t)), this.#a = null;
    for (const e of this.#w) window.clearTimeout(e);
    this.#w = [];
    for (const e of this.#g) window.clearTimeout(e);
    this.#g = [], this.#d !== null && window.cancelAnimationFrame(this.#d), this.#d = null, window.removeEventListener("resize", this.#t), window.removeEventListener("orientationchange", this.#t), window.visualViewport?.removeEventListener("resize", this.#t), window.visualViewport?.removeEventListener("scroll", this.#t), window.visualViewport?.removeEventListener("resize", this.#x), window.removeEventListener("orientationchange", this.#T), this.releaseBackgroundScroll();
  }
  syncFloatingCollision() {
    const e = document.querySelector(te)?.shadowRoot ?? null;
    e !== this.#L && (this.#u?.disconnect(), this.#u = null, this.#L = e, e && (this.#u = new MutationObserver(this.#t), this.#u.observe(e, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: [
        "class",
        "style",
        "hidden"
      ]
    })));
    const t = e?.querySelector(ie) ?? null;
    if (t !== this.#a && (this.#a && (this.#b?.unobserve(this.#a), this.#a.removeEventListener("transitionend", this.#t), this.#a.removeEventListener("animationend", this.#t)), this.#a = t, t)) {
      this.#b?.observe(t), t.addEventListener("transitionend", this.#t, { passive: !0 }), t.addEventListener("animationend", this.#t, { passive: !0 });
      for (const h of [
        100,
        500,
        1500
      ]) this.#w.push(window.setTimeout(this.#t, h));
    }
    if (!(t instanceof HTMLElement)) {
      this.style.removeProperty("--sanbera-ai-collision-bottom"), this.style.removeProperty("--sanbera-ai-aligned-right"), this.removeAttribute("data-accessibility-aligned");
      return;
    }
    const n = getComputedStyle(t), i = t.getBoundingClientRect(), s = n.display !== "none" && n.visibility !== "hidden" && Number(n.opacity || 1) > 0, r = window.visualViewport, o = {
      width: r?.width ?? window.innerWidth,
      bottom: (r?.offsetTop ?? 0) + (r?.height ?? window.innerHeight)
    }, l = s ? N(i, o) : null, c = s ? $(i, o.width) : null;
    l === null ? this.style.removeProperty("--sanbera-ai-collision-bottom") : this.style.setProperty("--sanbera-ai-collision-bottom", `${l}px`), c === null ? (this.style.removeProperty("--sanbera-ai-aligned-right"), this.removeAttribute("data-accessibility-aligned")) : (this.style.setProperty("--sanbera-ai-aligned-right", `${c}px`), this.setAttribute("data-accessibility-aligned", ""));
  }
  sampleClosedKeyboardViewport() {
    const e = window.visualViewport;
    if (!e) return;
    this.#k = e.height;
    const t = document.documentElement.clientHeight || window.innerHeight;
    this.#S = Math.max(0, Math.min(Math.round(t - (e.offsetTop + e.height)), t - A));
  }
  #T = () => {
    this.#p || this.sampleClosedKeyboardViewport(), this.#x();
  };
  #x = () => {
    const e = window.visualViewport;
    if (!e) return;
    this.#p || (this.#k = Math.max(this.#k ?? 0, e.height));
    const t = this.#k, n = this.#v && this.#p && t !== null && t - e.height >= ne;
    if (!this.#v) {
      this.removeAttribute("data-keyboard"), this.style.removeProperty("--sanbera-ai-bottom-inset"), this.style.removeProperty("--sanbera-ai-viewport-top");
      return;
    }
    if (!n) {
      this.removeAttribute("data-keyboard"), this.style.setProperty("--sanbera-ai-bottom-inset", `${this.#S}px`), this.style.removeProperty("--sanbera-ai-viewport-top");
      return;
    }
    const i = document.documentElement.clientHeight || window.innerHeight, s = i - (e.offsetTop + e.height), r = Math.max(this.#S, Math.min(Math.round(s), i - A));
    this.style.setProperty("--sanbera-ai-bottom-inset", `${r}px`), this.style.setProperty("--sanbera-ai-viewport-top", `${Math.max(0, Math.round(e.offsetTop))}px`), this.setAttribute("data-keyboard", "");
  };
  holdBackgroundScroll() {
    if (this.#E || !window.matchMedia(b).matches) return;
    const e = window.scrollY, t = document.body;
    this.#E = {
      scrollY: e,
      style: t.getAttribute("style") ?? ""
    }, t.style.position = "fixed", t.style.top = `-${e}px`, t.style.left = "0", t.style.right = "0", t.style.width = "100%", t.style.overflow = "hidden";
  }
  releaseBackgroundScroll() {
    const e = this.#E;
    if (!e) return;
    this.#E = null;
    const t = document.body;
    e.style ? t.setAttribute("style", e.style) : t.removeAttribute("style"), window.scrollTo(0, e.scrollY);
  }
  scheduleKeyboardSync() {
    for (const e of this.#g) window.clearTimeout(e);
    this.#g = [], this.#x();
    for (const e of [
      150,
      350,
      650
    ]) this.#g.push(window.setTimeout(this.#x, e));
  }
  syncShopifyPreviewOffset() {
    const e = globalThis.Shopify, t = !!document.querySelector("#PBarNextFrameWrapper, #PBarNextFrame");
    this.toggleAttribute("data-shopify-preview", e?.designMode === !0 || t);
  }
  open(e = {}) {
    this.sampleClosedKeyboardViewport(), this.#v = !0, this.removeAttribute("data-continuing"), this.holdBackgroundScroll(), this.#l.classList.remove("hidden"), this.#s.classList.add("hidden"), this.#s.setAttribute("aria-expanded", "true"), e.focus !== !1 && this.#i.focus(), this.#n.scrollTop = this.#n.scrollHeight, this.scheduleKeyboardSync(), this.persist();
  }
  close() {
    this.#v = !1, this.#p = !1, this.#S = 0, this.#l.classList.add("hidden"), this.#s.classList.remove("hidden"), this.#s.setAttribute("aria-expanded", "false"), this.#s.focus(), this.scheduleKeyboardSync(), this.releaseBackgroundScroll(), this.persist();
  }
  reset() {
    this.#e = [], this.#r = {}, this.#f = void 0, this.#i.value = "";
    try {
      sessionStorage.removeItem(m);
    } catch {
    }
    this.render(), this.persist(), this.#i.focus();
  }
  restore() {
    try {
      const e = JSON.parse(sessionStorage.getItem(m) ?? "null");
      e && typeof e.sessionId == "string" && (this.#f = e.sessionId), e && Array.isArray(e.history) && (this.#e = e.history.map((t) => re(t)).filter((t) => t !== null).slice(-10)), e && (this.#r = U(e.finder)), this.#I = !!(e && (e.open === !0 || e.resume === !0));
    } catch {
      try {
        sessionStorage.removeItem(m);
      } catch {
      }
    }
    this.render();
  }
  persist(e = {}) {
    try {
      sessionStorage.setItem(m, JSON.stringify({
        sessionId: this.#f,
        history: this.#e.slice(-10),
        finder: this.#r,
        open: this.#v,
        resume: e.resume === !0
      }));
    } catch {
    }
  }
  render() {
    this.#n.replaceChildren();
    const e = x[this.#o], t = g[this.#o];
    this.addMessage("assistant", e.welcome, []);
    for (const i of this.#e) this.addMessage(i.role, i.content, i.sources ?? []);
    const n = this.#e.at(-1);
    if (n?.role === "assistant" && n.question && !this.#h && this.addChoices(n.question), this.#y.replaceChildren(), this.#e.length === 0) {
      this.addSuggestion(t.start, () => this.startFinder(), !0);
      for (const i of e.suggestions) this.addSuggestion(i, () => this.ask(i));
    } else if (n?.finderResult && !this.#h) {
      for (const i of t.followUps) this.addSuggestion(i, () => this.ask(i));
      this.addSuggestion(t.restart, () => this.startFinder());
    }
    this.#n.scrollTop = this.#n.scrollHeight;
  }
  addSuggestion(e, t, n = !1) {
    const i = a("button", n ? "suggestion primary" : "suggestion", e);
    i.type = "button", i.addEventListener("click", t), this.#y.append(i);
  }
  ask(e) {
    this.#i.value = e, this.submit();
  }
  addMessage(e, t, n) {
    const i = a("div", `message ${e}`);
    if (i.dir = H(t), i.append(W(t)), this.#n.append(i), e === "assistant" && n.length) {
      const s = a("div", "links");
      s.dir = i.dir;
      for (const r of n) s.append(this.linkCard(r));
      this.#n.append(s);
    }
  }
  linkCard(e) {
    const t = a("a", "link-card");
    t.href = e.url;
    const n = a("span", "link-kind", X(e.url, this.#o)), i = a("span", "link-title", e.title), s = a("span", "link-where", J(e.url)), r = a("span", "link-arrow", "→");
    return r.setAttribute("aria-hidden", "true"), t.append(n, i, s, r), t.setAttribute("aria-label", `${e.title}, ${n.textContent ?? ""}, ${s.textContent ?? ""}`), t.addEventListener("click", (o) => {
      if (Z(e.url, location.href)) {
        o.preventDefault(), window.matchMedia(b).matches && this.close();
        return;
      }
      window.matchMedia(b).matches ? (this.releaseBackgroundScroll(), this.persist({ resume: !0 })) : this.persist();
    }), t;
  }
  addChoices(e) {
    const t = a("div", "choices");
    t.setAttribute("role", "group"), t.setAttribute("aria-label", E(e.step, this.#o).prompt);
    for (const n of e.choices) {
      const i = a("button", "choice", n.label);
      i.type = "button", i.addEventListener("click", () => this.chooseFinder(e.step, n)), t.append(i);
    }
    this.#n.append(t);
  }
  startFinder() {
    this.#h || (this.#r = {}, this.#e = this.#e.filter((e) => !e.finderTurn), this.#e.push({
      role: "user",
      content: g[this.#o].start,
      finderTurn: !0
    }), this.askFinderQuestion("audience"));
  }
  askFinderQuestion(e) {
    const t = E(e, this.#o);
    this.#e.push({
      role: "assistant",
      content: t.prompt,
      question: {
        step: e,
        choices: t.choices
      },
      finderTurn: !0
    }), this.#e = this.#e.slice(-10), this.persist(), this.render();
  }
  chooseFinder(e, t) {
    if (this.#h) return;
    const n = M(this.#r, e, t.value);
    if (n === this.#r) return;
    this.#r = n;
    const i = this.#e.at(-1);
    i?.question && delete i.question, this.#e.push({
      role: "user",
      content: t.label,
      finderTurn: !0
    });
    const s = P(this.#r);
    if (s) {
      this.askFinderQuestion(s);
      return;
    }
    if (C(this.#r)) {
      const r = j(this.#r, this.#o), o = this.#e.filter((l) => l.finderTurn && l.role === "user").slice(1).map((l) => l.content);
      this.#e = this.#e.filter((l) => !l.finderTurn), this.#e.push({
        role: "user",
        content: o.join(" · ")
      }), this.#e.push({
        role: "assistant",
        content: r.text,
        sources: r.links,
        finderResult: !0
      }), this.#e = this.#e.slice(-10), this.persist(), this.render();
    }
  }
  async submit() {
    const e = this.#i.value.normalize("NFKC").trim();
    if (!e || this.#h) return;
    this.#h = !0, this.#c.disabled = !0, this.#i.value = "";
    const t = this.#e.at(-1);
    t?.question && delete t.question, this.#e.push({
      role: "user",
      content: e
    });
    const n = this.#e.length;
    this.#e.push({
      role: "assistant",
      content: "…"
    }), this.render();
    try {
      const i = await this.chat(e, (s) => {
        this.#e[n] = {
          role: "assistant",
          content: s || "…"
        }, this.render();
      });
      this.#e[n] = {
        role: "assistant",
        content: i.answer,
        sources: i.sources
      };
    } catch {
      this.#e[n] = {
        role: "assistant",
        content: x[this.#o].error,
        sources: [{
          title: "Sanbera Contact",
          url: "https://www.sanbera.com/pages/contact"
        }]
      };
    } finally {
      this.#e = this.#e.slice(-10), this.persist(), this.render(), this.#h = !1, this.#c.disabled = !1, this.#i.focus();
    }
  }
  async chat(e, t) {
    const n = this.getAttribute("api-origin")?.replace(/\/$/u, "");
    if (!n || !n.startsWith("https://")) throw new Error("API_ORIGIN_NOT_CONFIGURED");
    const i = await fetch(`${n}/v1/chat`, {
      method: "POST",
      headers: {
        Accept: "text/event-stream",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        message: e,
        session_id: this.#f,
        context: Q(this.#r)
      }),
      credentials: "omit",
      mode: "cors",
      signal: AbortSignal.timeout(4e4)
    });
    if (!i.ok || !i.body) throw new Error(`CHAT_HTTP_${i.status}`);
    const s = i.body.pipeThrough(new TextDecoderStream()).getReader();
    let r = "", o = "";
    const l = [];
    for (; ; ) {
      const { value: c, done: h } = await s.read();
      r += c ?? "";
      const u = r.split(`

`);
      r = u.pop() ?? "";
      for (const p of u) {
        const f = p.match(/^event: (.+)$/mu)?.[1], y = p.match(/^data: (.+)$/mu)?.[1];
        if (!f || !y) continue;
        const d = JSON.parse(y);
        if (f === "meta" && typeof d.session_id == "string" && (this.#f = d.session_id), f === "delta" && typeof d.text == "string" && (o += d.text, t(o), await new Promise((v) => requestAnimationFrame(() => v()))), f === "sources" && Array.isArray(d.sources)) for (const v of d.sources) {
          const w = F(v);
          w && l.length < 3 && l.push(w);
        }
      }
      if (h) break;
    }
    if (!o) throw new Error("EMPTY_ANSWER");
    return {
      answer: o,
      sources: l
    };
  }
};
customElements.get("sanbera-ai-widget") || customElements.define("sanbera-ai-widget", ae);
